import { createSlice } from "@reduxjs/toolkit";
import { ITaskSlice } from "../../../models/master/task";


const initialTaskState: ITaskSlice = {
  tasks:undefined,
  task:undefined
};

const taskSlice = createSlice({
  name: "task",
  initialState: initialTaskState,
  reducers: {
    setTasks: (state, action: { payload: any }) => {
      state.tasks = action.payload;
    },
    setTask: (state, action: { payload: any }) => {
      state.task = action.payload;
    },
    
  },
});

export const { setTasks, setTask } =
  taskSlice.actions;

const tasksReducer = taskSlice.reducer;

export type taskState = ReturnType<typeof tasksReducer>;

export default tasksReducer;
